import { LOCALES, AVAILABLE_LOCALES } from 'localization/constants/configEnums';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import { IProductTemplate } from 'shared/types/ProductTemplate';
import { formatStringLowercaseWithDashes } from 'shared/utils/formatStringLowercaseWithDashes';

const getISODateString = (date: string) => {
  const d = new Date(date);

  // Return null if date is invalid.
  if (Number.isNaN(d.getTime())) return null;

  return d.toISOString();
};

const getProductCategory = (category: string) => {
  return category === 'shoes' || category === 'sneakers' ? 'sneakers' : 'apparel';
};

const getUrl = (productCategory: string, productSlug: string, locale: LOCALES) => {
  const baseURL = 'https://www.goat.com';
  let url = baseURL;

  if (locale !== LOCALES.enUS && AVAILABLE_LOCALES[locale]) {
    url = `${baseURL}/${locale}`;
  }
  return `${url}/${getProductCategory(productCategory)}/${formatStringLowercaseWithDashes(
    productSlug,
  )}`;
};

export const getEventSchema = (productTemplate: IProductTemplate, locale: LOCALES) => {
  const { mainPictureUrl, name, productCategory, releaseDate, slug } = productTemplate;
  const releaseDateISO = getISODateString(releaseDate); // Output "2023-06-25T23:59:59.999Z"
  const [displayReleaseDate] = releaseDateISO?.split('T'); // Extract date thats before the "T" in the releaseDateISO
  const url = getUrl(productCategory, slug, locale);

  return JSON.stringify(
    omitBy(
      {
        '@context': 'http://schema.org',
        '@type': 'Event',
        name,
        image: mainPictureUrl,
        description: `The ${name} will release on ${displayReleaseDate} on GOAT.com`,
        url,
        startDate: displayReleaseDate,
        endDate: displayReleaseDate,
        location: {
          '@type': 'VirtualLocation',
          url,
        },
        eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
        eventStatus: 'https://schema.org/EventScheduled',
        organizer: {
          '@type': 'Organization',
          name: 'GOAT',
          url: 'https://www.goat.com/',
        },
      },
      isNil,
    ),
  );
};
